import { stablecoinsSearchSchema } from "@blockdaemon/widget-host";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { DefiTokensPage } from "../../features/defi/pages/defi-tokens-page";

export const Route = createFileRoute("/_layout/defi/stablecoins/")({
  component: DefiTokensPage,
  validateSearch: zodValidator(stablecoinsSearchSchema),
});
